module.exports = __webpack_public_path__ + "img/badge_neuundexklusiv.9b2dbe4.png";